import React from "react";

function Modal(){
    return <div className="modalBackground"></div>
}

export default Modal;